import { defineStore } from 'pinia';
import { strapi } from '../transport/strapi';
import type { IAutochangeData, IAutochangeDataStrapiResponse } from '~/types/autochangeData';

export const useStoreAutochangeData = defineStore('autochangeData', {
  state: () => ({
    autochangeItems: [] as IAutochangeData[],
    requestPromise: null as Promise<IAutochangeDataStrapiResponse> | null,
  }),

  actions: {
    async loadAutochangeData() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('autochanges-data')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const filteredState = this.autochangeItems.filter(
          (item) => !response.data.find(({ id }) => id && id === item.id)
        );

        this.autochangeItems = [...filteredState, ...response.data];

        return true;
      } else {
        return false;
      }
    },
  },
});
